import { FormModel } from "components/Form";
import { Validators } from "utils/validators";


export const ProductFilterFormCoupon = (strings?: any, width = 4): FormModel[] => {
  return [
    {
      label: 'Product Code',
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'productCode',
      validators:[],
      responsive: { xs: 12 },
      required: false,
      width: width
    },
    {
      label: 'Product Name',
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'string',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [] ,
      responsive: { xs: 12 },
      required: false,
      width: width
    },
  ];
};
